import { useState, useEffect, useMemo } from 'react';
import ax, { GET_CUSTOM_FIELD_DATA, DELETE_PRODUCT_CUSTOM_FIELDS } from '%/axios';
import useDebounce from '../hooks/useDebounce';
export const Combobox = (props) => {

  const {
    list = [],
    handleChange,
    idx = -1,
    value = '',
    handleDelete,
    limit = 5,
    inputClassName = 'input-field w-input',
    placeholder = ''
  } = props;

  const [show, setShow] = useState(false);


  const onChange = (val) => {
    handleChange(val);
  }

  return (
    <>
      <input
        value={value}
        placeholder={placeholder}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        onChange={e => onChange(e.target.value)}
        class={inputClassName}
      />
      {
        handleDelete &&
        <div
          class="variant-option-delete-wrapper cursor-ptr"
          onClick={handleDelete}
        >
          <div class="variant-option-delete-icon w-embed"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z" fill="currentColor"></path>
          </svg>
          </div>
        </div>
      }
      {
        (show) &&
        <nav class="product-actions-dropdown-list w-dropdown-list show-actions w--open combobox"
        >


          {list
            .filter(each => (new RegExp(value, 'ig')).test(each))
            .filter(each => each != value)
            .slice(0, limit)
            .map(each =>
              <div class="product-actions-dropdown-link w-inline-block cursor-ptr"
                onMouseDown={(e) => { e.preventDefault(); onChange(each) }}
              >{each}</div>
            )}
        </nav>
      }
    </>

  )
}

// {[name]: [{id: 1, description: 'foo'}, {id: 2, description: 'bar}]}

const CustomFieldItem = (props) => {

  const {
    name,
    values = [],
    setCustomFields,
    dbUpdateDictionary,
    idx,
    dictionary,
    dictionaryKeys
  } = props;

  const handleDelete = async (list = [], type = 'group', i = -1) => {
    const check = confirm(`Delete the custom field ${type}?`)
    if (!check) return;

    try {

      const res = await ax(DELETE_PRODUCT_CUSTOM_FIELDS, { list })

      if (type == 'group') {
        if (res) {
          console.log(`Deleted ${res?.count} custom fields.`)
          alert(`Deleted.`)
        }
      }
        setCustomFields(prev => {
          const cpy = [...prev];
          cpy.splice(idx, 1);
          return cpy;
        });

      if (type == 'item')
        setCustomFields(prev => {
          const cpy = [...prev];
          const cpyValues = [...cpy[idx].values];
          cpyValues.splice(i, 1);
          cpy[idx].values = cpyValues;
          return cpy;
        })
      

    } catch (er) {
      console.error(er);
      alert('Could not delete custom fields.')
    }
  }



  useEffect(() => {
    if (name)
      dbUpdateDictionary('description', name)
  }, [name])

  return (
    <nav class="variants-dropdown-list w-dropdown-list w--open">
      <div class="variant-option-add-wrapper"
        style={{ display: 'block' }}
      >
        <div class="w-layout-grid varian  t-add-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div id="w-node-_55c0b544-c677-347f-68c6-fc41995a3c36-fd21fe12" class="variant-add-column-wrapper">
            <div class="form-block _100-width w-form">
              <div id="email-form-2" class="form-wrapper" >
                <div class="inventory-form-elements-wrapper">
                  <div class="input-field-wrapper"><label for="name-3" class="field-label">Name</label>
                    <Combobox
                      type='name'
                      value={name}
                      list={(dictionaryKeys)}
                      handleChange={value => {
                        setCustomFields(prev => {
                          const cpy = [...prev];
                          cpy[idx].name = value;
                          return cpy;
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={() => handleDelete(values.filter(each => each?.id)
                .map(each => each?.id))}
              class="variants-dropdown-toggle-wrapper delete top-10 cursor-ptr">
              <div class="variants-delete-icon w-embed">
                <svg width="20" height="20" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_463_2)">
                    <path d="M24.86 49.9599C11.6 50.1099 -0.00999354 38.9599 6.45518e-06 24.9099C0.0100065 11.5799 11.1 -0.100095 25.24 -9.49728e-05C38.49 0.099905 50.07 11.1299 50 25.1899C49.93 38.4499 38.91 50.1899 24.86 49.9599ZM25.12 44.9499C36.62 44.5499 44.9 35.9399 44.86 24.7799C44.82 13.3599 36 5.1599 24.88 5.1399C13.38 5.1099 5.10001 14.0499 5.14001 25.2199C5.18001 36.6399 14 44.4899 25.12 44.9599V44.9499Z" fill="currentColor"></path>
                    <path d="M37.4 27.46C34.01 27.46 15.98 27.57 12.65 27.57V22.48C15.96 22.48 34.06 22.5 37.4 22.5" fill="currentColor"></path>
                    <path d="M27.48 22.5H37.39V27.45" fill="currentColor"></path>
                  </g>
                  <defs>
                    <clippath id="clip0_463_2">
                      <rect width="50" height="49.96" fill="white"></rect>
                    </clippath>
                  </defs>
                </svg></div>
              <div>Delete Field</div>
            </div>
          </div>
          <div id="w-node-_55c0b544-c677-347f-68c6-fc41995a3c4c-fd21fe12" class="variant-add-column top-align">
            <div class="form-block _100-width w-form">
              <div class="form-wrapper" >
                <div class="inventory-form-elements-wrapper">
                  <div class="input-field-wrapper"><label for="field-7" class="field-label">Values</label>
                    {values?.map((each, i) =>
                      <Combobox
                        type='description'
                        list={dictionary[name] || []}
                        value={each.description}
                        handleChange={value => {
                          setCustomFields(prev => {
                            const cpy = [...prev];
                            const cpyValues = [...cpy[idx].values];
                            cpyValues[i] = {
                              ...cpyValues[i],
                              description: value
                            };
                            cpy[idx].values = cpyValues;
                            return cpy;
                          });
                        }}
                        handleDelete={() =>
                          handleDelete([each?.id], 'item', i)

                        }
                      />
                    )}
                  </div>

                  <div
                    onClick={() => {
                      setCustomFields(prev => {
                        const cpy = [...prev];
                        cpy[idx].values = [...cpy[idx].values, { description: '' }];
                        return cpy;
                      });

                    }}
                    class="variants-dropdown-toggle-wrapper cursor-ptr">
                    <div class="variants-add-icon w-embed">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20Z" fill="currentColor"></path></svg>
                    </div>
                    <div>Add another value</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </nav>
  )


}

const CustomFieldSection = (props) => {

  const {
    customFields,
    setCustomFields
  } = props;

  const [dictionary, setDictionary] = useState({});
  const dictionaryKeys = useMemo(() => Object.keys(dictionary), [dictionary])

  const updateDictionary = async (type = 'name', name = '') => {
    try {
      const res = await ax(GET_CUSTOM_FIELD_DATA, { type, name });
      if (res) {
        if (type == 'name') {


          setDictionary(res.reduce((acc, each) => {
            acc[each] = [];
            return acc;
          }, {}))
        } else {
          setDictionary(prev => ({
            ...prev,
            [name]: res
          }))
        }
      }
    } catch (er) {
      console.error(er);
    }


  }
  const { debounceFn: dbUpdateDictionary } = useDebounce(updateDictionary)


  const handleAddValue = (idx) => {
    const cpy = [...customFields];
    cpy[idx] = [...cpy[idx], { description: '' }];
    setCustomFields(cpy);
  }

  useEffect(() => {
    dbUpdateDictionary();
  }, [])

  return (
    <div id="custom-fields" class="module-panel-wrapper">
      <h3>Custom Fields</h3>
      <div class="tab-content-wrapper top-20">
        <div data-hover="false" data-delay="0" class="variants-dropdown w-dropdown">

          {(customFields)?.map((each, idx) =>

            <CustomFieldItem
              idx={idx}
              name={each?.name}
              values={each.values}
              setCustomFields={setCustomFields}
              handleAddValue={() => handleAddValue(idx)}
              dbUpdateDictionary={dbUpdateDictionary}
              dictionary={dictionary}
              dictionaryKeys={dictionaryKeys}
            />
          )}
        </div>
        <div
          onClick={() => setCustomFields(prev => ([
            ...prev,
            {
              name: `Custom Field Name ${(customFields).length}`,
              values: [{ description: '' }]
            }

          ]))}
          class="variants-dropdown-toggle w-dropdown-toggle">
          <div class="variants-add-icon w-embed"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20Z" fill="currentColor"></path>
          </svg>
          </div>
          <div>Add custom field option</div>
        </div>
      </div>
    </div>
  )
}
export default CustomFieldSection;